import { blogApiBase } from '../config';
import { getAccess } from './tokenStore';
import { refreshTokens } from './authApi';

// Thrown when a request is unauthorized and a refresh could not recover it.
// Consumers catch this to force sign-out.
export class UnauthorizedError extends Error {
  constructor() {
    super('Unauthorized');
    this.name = 'UnauthorizedError';
  }
}

function doFetch(path: string, init: RequestInit): Promise<Response> {
  const access = getAccess();
  const headers = new Headers(init.headers);
  if (access) headers.set('Authorization', `Bearer ${access}`);
  return fetch(`${blogApiBase()}${path}`, { ...init, headers });
}

// Authenticated fetch with one reactive refresh+retry on 401.
export async function authFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const res = await doFetch(path, init);
  if (res.status !== 401) return res;

  const refreshed = await refreshTokens();
  if (!refreshed) throw new UnauthorizedError();

  const retry = await doFetch(path, init);
  if (retry.status === 401) throw new UnauthorizedError();
  return retry;
}
